export class NavigationItem {

  public constructor(
    public id: string,
    public route: string,
    public label: string,
    public icon: string = ''
  ) {
  }
}
